<template>
  <service>
    <div class="service-area">
      <div class="element-1">
        <div class="input-item your-service-area">
          <h3>Select city (city may not active due to lack of photographer)</h3>
          <dropdown-menu-type-4
            :data="city"
            v-model="forms.city"
          ></dropdown-menu-type-4>
        </div>
      </div>
      <div class="element-1 google-map">
        <google-map
          v-if="forms.location"
          :inputBox="1"
          v-model="forms.location"
        ></google-map>
      </div>
      <div class="element-1">
        <div class="input-item">
          <h3>ABOUT THE LOACTION</h3>
          <textarea v-model="forms.aboutTheLocation"></textarea>
        </div>
      </div>
      <div class="element-1">
        <div class="input-item">
          <h3>HOW TO GET HERE</h3>
          <textarea v-model="forms.howToGetHere"></textarea>
        </div>
      </div>
      <div class="element-1">
        <div class="input-item">
          <h3>BY SEARCH – YOUR COVERED AREA</h3>
          <textarea v-model="forms.bySearch"></textarea>
        </div>
      </div>
      <div class="element-1" v-if="false">
        <div class="input-item">
          <h3>PORTFOLIO – CAN UPLOAD MAXIUM 6 PHOTO</h3>
          <div class="upload-box">
            <image-upload-type-4
              v-on:model="v => setPortfolio(v)"
              :importPreviewImages="portfolio"
              directory="/service_area_portfolio"
            ></image-upload-type-4>
          </div>
        </div>
      </div>

      <div class="element-1">
        <div class="input-item submit">
          <base-button-type-1
            text="CANCEL"
            typeColor="white"
            @click="$router.push({ path: '/photographer/service' })"
          ></base-button-type-1>
          <base-button-type-1
            text="OK"
            typeColor="blue"
            @click="save"
          ></base-button-type-1>
        </div>
      </div>
    </div>
  </service>
</template>

<script>
import Service from './Service'
// import DropdownMenuType3 from '@/components/common/DropdownMenuType3'
import BaseButtonType1 from '../common/form-elemnets/BaseButtonType1'
import GoogleMap from '../common/GoogleMap'
import { getCities } from '../../api/common_code'
import ImageUploadType4 from '../common/ImageUploadType4'
// import ImageUploadType1 from '@/components/common/ImageUploadType1'
import { defaultStore } from '../../library/firebase'
import DropdownMenuType4 from '../common/DropdownMenuType4'

export default {
  name: 'service-area',
  components: {
    DropdownMenuType4,
    // ImageUploadType1,
    ImageUploadType4,
    GoogleMap,
    BaseButtonType1,
    // DropdownMenuType3,
    Service
  },
  data() {
    return {
      city: {
        address: {
          placeId: '',
          detail: '',
          placeName: ''
        }
      },
      citySelectedIndex: 0,
      forms: {
        city: '',
        aboutTheLocation: '',
        howToGetHere: '',
        bySearch: '',
        portfolio: [],
        location: {
          gps: '',
          address: {
            placeId: '',
            detail: '',
            placeName: ''
          }
        }
      },
      location: {
        gps: '',
        address: {
          placeId: ''
        }
      },
      portfolio: []
    }
  },
  created() {
    this.getDefaultData()
  },
  methods: {
    updateGoogleMap() {
      console.log('google map updated')
    },
    getServiceArea() {
      defaultStore
        .collection('photographers_service_area')
        .doc(this.$store.getters.userInfo.uid)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.forms = doc.data()
            this.portfolio = doc.data().portfolio
            // this.location = doc.data().location
            console.log('get location:', doc.data().location)
          } else {
            this.forms.location = this.city[Object.keys(this.city)[0]]
            console.log('not data', this.city[Object.keys(this.city)[0]])
          }
        })
    },
    save() {
      // console.log('service area save:', this.forms)
      // console.log('user info:', this.$store.getters.userInfo.uid)
      defaultStore
        .collection('photographers_service_area')
        .doc(this.$store.getters.userInfo.uid)
        .set(this.forms)
        .then(() => {
          defaultStore
            .collection('photographers_service')
            .where('uid', '==', this.$store.getters.userInfo.uid)
            .get()
            .then(snap => {
              let updateCount = snap.size
              snap.forEach((doc, index) => {
                defaultStore
                  .collection('photographers_service')
                  .doc(doc.id)
                  .update({ city: this.forms.city })
                  .then(() => {
                    console.log(`${doc.id} is updated for city`)
                  })
                if (updateCount === index + 1) {
                  alert('Success')
                }
              })
            })

          this.$router.push({ path: '/photographer/service' })
        })
    },
    setPortfolio(value) {
      // console.log('update file upload:', value)
      this.forms.portfolio = value
    },
    getDefaultData() {
      getCities().then(res => {
        delete res.All
        console.log('city lists: ', res)
        this.city = res
        this.getServiceArea()
      })
    }
  },
  watch: {
    // 'forms.location'(value) {
    // // this.forms.location = value
    // console.log('Updated location:', value)
    // this.forms.location = value
    // },
    'forms.city'(newValue, oldValue) {
      console.log('Updated forms.city new value:', newValue)
      console.log('Updated forms.city old value', oldValue)
      if (!this.forms.location) {
        // let cityLocationInfo = this.city[newValue]
        // this.location = cityLocationInfo
        this.forms.location = this.city[newValue]
      }

      if (oldValue) {
        // let cityLocationInfo = this.city[newValue]
        // this.location = cityLocationInfo
        this.forms.location = this.city[newValue]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.service-area {
  width: 100%;
  height: auto;
  margin-top: 40px;
  padding-bottom: 20px;
  border: 1px solid #e7e7e7;

  .element-1 {
    &:nth-child(1) {
      margin-top: 22px;
    }

    margin: 14px 20px 0 20px;
    display: flex;
    justify-content: flex-start;
    min-height: 50px;
    position: relative;

    .input-item {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;

      textarea {
        height: 100px;
        background-color: #ffffff;
        border: solid 1px #e7e7e7;
        width: 1030px;
        outline: none;
        resize: none;
      }

      h3 {
        font-size: 14px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;
        margin: 0 0 5px 0;
      }

      &.your-service-area {
        width: 100%;
      }

      &.price {
        margin-left: 40px;
        width: 30%;
      }

      &.promote {
        width: 83%;
      }

      .upload-box {
        width: 100%;
        height: 226px;
        background-color: #f5f5f5;
        border: solid 1px #e7e7e7;
        position: relative;

        .base-button-type-1 {
          position: absolute;
          right: 10px;
          bottom: 10px;
        }
      }

      &.submit {
        position: absolute;
        right: 0;
        flex-direction: row;
        justify-content: space-between;
        width: 320px;
        justify-self: flex-end;
      }
    }

    &.google-map {
      width: 1040px;
      height: 400px;
      display: block;
    }
  }
}
</style>
